// extracted by mini-css-extract-plugin
export default {"keyFeature":"styles__keyFeature__b40418fd168b3e97fec3","tick":"styles__tick__d304a33c73cc0370096e","heading":"styles__heading__b7a77a35f19d04f713ec"};